import React, { useMemo } from 'react';

import moment from 'moment';

import { Desktop } from 'components/Responsive';

import {
  Container,
  Description,
  Text,
  Icon,
  InfoContainer,
  DateContainer,
  Line,
  LineContainer,
  Divider,
  Hour,
} from './styles';

export interface Props {
  date: Date;
  title: string | JSX.Element;
  description?: string | JSX.Element;
  icon: string;
  showHour?: boolean;
  noSeparator?: boolean;
}

const TimelineItem = ({ date, title, description, icon, showHour, noSeparator }: Props) => {
  const formattedDate = useMemo(() => moment(date).format('DD/MM'), [date]);
  const formattedHour = useMemo(() => moment(date).format('hh[:]mm a'), [date]);

  return (
    <>
      <Container>
        <DateContainer>
          <Text>{formattedDate}</Text>
          {showHour && <Hour>{formattedHour}</Hour>}
        </DateContainer>
        <LineContainer>
          <Icon src={icon} alt="" />
          {!noSeparator && <Line />}
        </LineContainer>
        <InfoContainer>
          <Text>{title}</Text>
          <Description>{description}</Description>
          {!noSeparator && (
            <Desktop>
              <Divider />
            </Desktop>
          )}
        </InfoContainer>
      </Container>
    </>
  );
};

export default TimelineItem;
